import { Navigate } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";

/**
 * PublicRoute component that prevents authenticated users from accessing public routes (login/register).
 * If user is already authenticated, redirects to content page.
 * @param {Object} props - Route component props
 * @param {JSX.Element} props.element - The component to render if not authenticated
 * @returns {JSX.Element} The public component or redirect to content
 */
const PublicRoute = ({ element }) => {
  const { isAuthenticated } = useAuthContext();
  return isAuthenticated ? <Navigate to="/content" replace /> : element;
};

export default PublicRoute;
